import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  RewardListReq,
  RewardListRes,
  CreateRewardReq,
  ActionRewardRes,
  UpdateRewardReq,
  DeleteRewardReq,
  RewardDetailReq,
  RewardDetailRes,
  RedeemRewardReq,
} from './types'

export const getRewardListAction = createAsyncAction(
  'REWARD/GET_REWARD_LIST_REQ',
  'REWARD/GET_REWARD_LIST_SUCCESS',
  'REWARD/GET_REWARD_LIST_FAILURE',
)<RewardListReq, RewardListRes, Error>()

export const getRewardDetailAction = createAsyncAction(
  'REWARD/GET_REWARD_DETAIL_REQ',
  'REWARD/GET_REWARD_DETAIL_SUCCESS',
  'REWARD/GET_REWARD_DETAIL_FAILURE',
)<RewardDetailReq, RewardDetailRes, Error>()

export const createRewardAction = createAsyncAction(
  'REWARD/CREATE_REWARD_REQ',
  'REWARD/CREATE_REWARD_SUCCESS',
  'REWARD/CREATE_REWARD_FAILURE',
)<CreateRewardReq, ActionRewardRes, Error>()

export const updateRewardAction = createAsyncAction(
  'REWARD/UPDATE_REWARD_REQ',
  'REWARD/UPDATE_REWARD_SUCCESS',
  'REWARD/UPDATE_REWARD_FAILURE',
)<UpdateRewardReq, ActionRewardRes, Error>()

export const deleteRewardAction = createAsyncAction(
  'REWARD/DELETE_REWARD_REQ',
  'REWARD/DELETE_REWARD_SUCCESS',
  'REWARD/DELETE_REWARD_FAILURE',
)<DeleteRewardReq, ActionRewardRes, Error>()

export const reedeemRewardAction = createAsyncAction(
  'REWARD/REDEEM_REWARD_REQ',
  'REWARD/REDEEM_REWARD_SUCCESS',
  'REWARD/REDEEM_REWARD_FAILURE',
)<RedeemRewardReq, ActionRewardRes, Error>()

export const clearEventAction = createStandardAction('REWARD/CLEAR_EVENT')<void>()
